import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import cloudNetworkHero from "../assets/Hero/cloud-computing.png"; // Replace with your hero image
import cloudNetworkImage from "../assets/Hero/Network-diagram.png"; // Replace with your cloud network image
import "../assets/css/cloudNetworkDesignPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const cloudNetworkData = {
  hero: {
    title: "Cloud Network Design",
    subtitle: "Build Scalable and Secure Cloud Networks for Your Business",
  },
  introduction: {
    heading: "Why Cloud Network Design Matters",
    paragraphs: [
      "Cloud network design is essential for creating scalable, secure, and efficient cloud infrastructures that support your business operations.",
      "Our cloud network solutions are designed to provide seamless connectivity, robust security, and optimized performance for your cloud environments.",
    ],
  },
  cta: {
    heading: "Ready to Design Your Cloud Network?",
    text: "Contact us today to learn more about our Cloud Network Design Solutions and how we can help your business thrive.",
  },
};

export const CloudNetworkDesignPage = ({ data }) => {
  const cloudNetworkRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = cloudNetworkRef.current.querySelectorAll(".cloud-network-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: cloudNetworkRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="cloud-network-page" ref={cloudNetworkRef}>
      {/* Hero Section */}
      <div
        className="cloud-network-hero-section"
        style={{ backgroundImage: `url(${cloudNetworkHero})` }}
      >
        <h1 className="cloud-network-animate">{cloudNetworkData.hero.title}</h1>
        <p className="cloud-network-animate">{cloudNetworkData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container cloud-network-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="cloud-network-animate">{cloudNetworkData.introduction.heading}</h2>
            {cloudNetworkData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="cloud-network-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 cloud-network-image-container">
            <img
              src={cloudNetworkImage}
              className="img-fluid cloud-network-animate"
              alt="Cloud Network Design"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container cloud-network-cta">
        <h2 className="cloud-network-animate">{cloudNetworkData.cta.heading}</h2>
        <p className="cloud-network-animate">{cloudNetworkData.cta.text}</p>
        <button
          className="btn btn-primary cloud-network-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};